@if (currentContext$ | async; as currentContext) {
  @if (currentContext !== 'NONE') {
    <div
      class="root"
      [style.width]="widthsByContext()[currentContext] || windowWidthSmall"
      >
      <div class="selection-container" [class.home-view]="currentContext === 'HOME'">
        <ng-container >
          @if (currentContext !== 'EDIT_TRAFFIC_DEVIATION_TEMPLATES' && currentContext !== 'HOME') {
            <app-blade-header (closeClicked)="closePanel()">
              <ng-container title>
                @switch (currentContext) {
                  @case ('HOME') {
                    <span translate>Home</span>
                  }
                  @case ('VEHICLE') {
                    <span translate>Vehicles</span>
                  }
                  @case ('PUNCTUALITY') {
                    <span translate>Punctuality</span>
                  }
                  @case ('LINE') {
                    <span translate>Routes</span>
                  }
                  @case ('WARNING') {
                    <span translate>Warnings</span>
                  }
                  @case ('HISTORY') {
                    <span translate>Position history</span>
                  }
                  @case ('REGISTEDAMAGERISK') {
                    <span translate>Register Damage Risk</span>
                  }
                  @case ('NEW_TRAFFIC_DEVIATION') {
                    <span translate>New deviation</span>
                  }
                  @case ('TRAFFIC_DEVIATIONS') {
                    <span translate>Deviations</span>
                  }
                  @case ('SETTINGS') {
                    <span translate>Settings</span>
                  }
                  @default {
                    <span translate>Selection</span>
                  }
                }
                @if (nrItems() !== undefined && nrItems() > 0) {
                  <span class="left-margin tag mini-tag">
                    {{nrItems()}}
                  </span>
                }
              </ng-container>
            </app-blade-header>
          }
          @if (!isNoGarageSelected()) {
            @switch (currentContext) {
              @case ('HOME') {
                <app-home-view></app-home-view>
              }
              @case ('VEHICLE') {
                <app-vehicle-selection-overview (nrItems)="updateNrItems($event)"
                ></app-vehicle-selection-overview>
              }
              @case ('PUNCTUALITY') {
                <app-punctuality-selection-overview></app-punctuality-selection-overview>
              }
              @case ('LINE') {
                <app-line-selection-overview (nrItems)="updateNrItems($event)"
                ></app-line-selection-overview>
              }
              @case ('WARNING') {
                <app-warning-selection-overview></app-warning-selection-overview>
              }
              @case ('HISTORY') {
                <app-history></app-history>
              }
              @case ('REGISTEDAMAGERISK') {
                <app-register-damage-risk></app-register-damage-risk>
              }
              @case ('NEW_TRAFFIC_DEVIATION') {
                <create-new-traffic-deviation-overview></create-new-traffic-deviation-overview>
              }
              @case ('TRAFFIC_DEVIATIONS') {
                <app-traffic-deviations-select-overview></app-traffic-deviations-select-overview>
              }
              @case ('EDIT_TRAFFIC_DEVIATION_TEMPLATES') {
                <app-edit-traffic-deviation-templates-overview>
                </app-edit-traffic-deviation-templates-overview>
              }
              @case ('SETTINGS') {
                <app-settings-overview></app-settings-overview>
              }
              @default {
                <div></div>
              }
            }
          } @else {
            <app-feedback-text type="information">
              {{ 'Please select a garage in the top right corner to see its active vehicle data here' | translate}}
            </app-feedback-text>
          }
        </ng-container>
      </div>
    </div>
  }
}